export default __webpack_public_path__ + "static/media/search-icon.4971e8d7.svg";